import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SavePlanComponent } from './save-plan.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [SavePlanComponent],
  imports: [
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule    
  ],
  entryComponents:[SavePlanComponent],
  bootstrap:[SavePlanComponent]  
})
export class SavePlanModule { }
